import React, { useState, useEffect } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as wjCore from '@mescius/wijmo'
import * as wjcGrid from '@mescius/wijmo.grid'
import * as wjGrid from '@mescius/wijmo.react.grid'
import { FlexGridFilter } from '@mescius/wijmo.react.grid.filter'
import '@mescius/wijmo.cultures/wijmo.culture.ja'
import customContextMenu from '../../wijmo/customContextMenu'
import ErrorBoundary from '../ErrorBoundary'

//

const months = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3]
export default function XrRightsGrid (props) {
  const [rightsCV, setRightsCV] = useState(null)

  useEffect(() => {
    if (!rightsCV) {
      props.rights.forEach((right) => {
        right.tax_sum = 0
        right.add_bf_taxes.forEach((tax) => {
          right[`tax-${tax.month}`] = tax.add_bf_tax
          right.tax_sum += tax.add_bf_tax
        })
        months.forEach((month) => {
          if (!(`tax-${month}` in right)) {
            right[`tax-${month}`] = 0
          }
        })
      })
      const _rightsCV = new wjCore.CollectionView(props.rights, {
        calculatedFields: {
          tax_diff: (obj) => obj.tax_sum - obj.mg_bf_tax
        }
      })
      setRightsCV(_rightsCV)
    }
  }, [rightsCV])

  const gridInit = (grid) => {
    customContextMenu(grid)
    // 集計行の設定
    grid.columnFooters.rows.push(new wjcGrid.GroupRow())
  }

  return (
    <div className="d-inline-block w-100 text-center">
      {rightsCV && (
        <wjGrid.FlexGrid showMarquee={true} stickyHeaders={true} itemsSource={rightsCV} isReadOnly={true}
          frozenColumns={6} initialized={gridInit} keyActionTab={wjcGrid.KeyAction.Cycle}>
          <FlexGridFilter />
          <wjGrid.FlexGridColumn header="ID" binding="con_id" cssClassAll="wj-style-basic" width={120} />
          <wjGrid.FlexGridColumn header="キャラクター名" binding="character.title" cssClassAll="wj-style-basic" width={200} />
          <wjGrid.FlexGridColumn header="キャラクターメモ" binding="memo" cssClassAll="wj-style-basic" width={80} />
          <wjGrid.FlexGridColumn header="目標額" binding="mg_bf_tax" cssClassAll="wj-style-green" width={100} format="C0" aggregate='Sum' />
          <wjGrid.FlexGridColumn header="売上合計" binding="tax_sum" cssClassAll="wj-style-green" width={100} format="C0" aggregate='Sum' />
          <wjGrid.FlexGridColumn header="差額" binding="tax_diff" cssClassAll="wj-style-green" width={100} format="C0" aggregate='Sum' />
          {months.map((month) => {
            return (
              <wjGrid.FlexGridColumn header={`${month}月`} binding={`tax-${month}`} cssClassAll="wj-style-orange" width={100} dataType={2} format="C0" key={`col-m${month}`} aggregate='Sum' />
            )
          })}
        </wjGrid.FlexGrid>
      )}
    </div>
  )
}

XrRightsGrid.propTypes = {
  rights: PropTypes.arrayOf(PropTypes.object)
}

$('#xr-rights-grid').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <XrRightsGrid {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
